export const createdBySystemNameMappings = {
  system: $localize`System`,
  trigger: $localize`Automation`,
  recurring: $localize`Recurring`,
  ai: $localize`AI Bot`,
}
